import API from 'services/api';

export const updateBillingInformation = ({ payload }: { payload: any }) => {
  return API.put('/api/customers/account', payload);
};
